import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import { Link } from "react-router";
import Image from "common/components/image";

const CATEGORIES = [
  {
    name: "Logo & Branding",
    image: "blackfish-beer-company-homepage+image.png",
    url: "/logo-design/",
  },
  {
    name: "Website design",
    image: "Macbook+Pro+-+Dark+Background+1.png",
    url: "/website-design/",
  },
  {
    name: "Business & advertising",
    image: "business-and-advertising-image.png",
    url: "/categories/?visit=business-advertising",
  },
  {
    name: "Packaging & label",
    image: "regine-packaging+3.png",
    style: { background: "#F7B868", paddingTop: "9px" },
    imageStyle: { transform: "scale(0.9)" },
    url: "/packaging-design/",
  },
  {
    name: "Business name",
    image: "Splendoor+image.png",
    url: "/naming-a-business-or-product/",
  },
];

const Categories2 = ({ background }) => {
  return (
    <section className={cn("block block-categories-2 text-center", background)}>
      <div className="row columns">
        <div className="block-header">
          <h2>Designs handcrafted for your unique brand</h2>
        </div>
      </div>
      <div className="row align-middle small-up-1 medium-up-3 large-up-5">
        {CATEGORIES.map((cat, i) => (
          <div className="column small-gutter" key={i}>
            <div className="box" style={cat.style}>
              <Link to={cat.url}>
                <Image
                  widths={[250]}
                  src={cat.image}
                  alt={cat.name}
                  style={cat.imageStyle}
                />
                <h3>{cat.name}</h3>
              </Link>
            </div>
          </div>
        ))}
      </div>
      <Link to="/categories/" className="as-h3-important">
        Explore all custom design and naming categories
      </Link>
    </section>
  );
};

Categories2.propTypes = {
  background: PropTypes.string,
};

export default Categories2;
